/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
// gatsby-browser.js
// gatsby-browser.js
const { wrapPageElement } = require('./src/i18n/wrapPageElement');
exports.wrapPageElement = wrapPageElement;